module.exports = __webpack_public_path__ + "static/img/bg.5c87f78f.png";